/* eslint-disable sonarjs/cognitive-complexity */
import { useAppDispatch, useAppSelector } from "hooks";
import React, { useEffect, useState } from "react";
import { simFlowFetchData, simFlowFetchSimRequestData } from "../../../../redux/simFlow/simFlowSlice";
import CommonLoader from "components/CommonLoader";

type OrderChangeResponseFromSimEngineProps = {
  id: any;
};

function OrderChangeResponseFromSimEngine({ id }: OrderChangeResponseFromSimEngineProps) {
  const dispatch = useAppDispatch();

  const simSelectorData = useAppSelector((state) => state.simFlow.simFlow.data[0]?.data || {});
  const simError = useAppSelector((state) => state.errorStep.simError);
  const simSelectorLoading = useAppSelector((state) => state.simFlow.simFlow.loading);

  const [simSelector, setSimSelector] = useState<any>(simSelectorData);

  const isError = simError ? simError.step >= 9 : false;
  const isAlreadyFetched = Array.isArray(simSelectorData)
    ? false
    : "status" in simSelectorData
      ? true
      : simSelectorData.flow_dtl_id === Number(id);

  useEffect(() => {
    if (!isError && !isAlreadyFetched) {
      dispatch(simFlowFetchData());
      dispatch(simFlowFetchSimRequestData({ id, stepId: 9 }));
    } else {
      setSimSelector(simSelectorData);
    }
  }, [dispatch, id, isAlreadyFetched, isError, simSelectorData]);

  const responseData = simSelector?.response_json || {};
  // console.log("responseData", responseData?.factoryOptionList);
  // console.log("responseData", responseData);
  const vehicleIdentifierData = [
    { id: 1, name: "URN", value: responseData?.urn ?? "" },
    { id: 2, name: "RTO ID", value: responseData?.rtoId ?? "" },
    { id: 3, name: "Model No.", value: responseData?.modelNo ?? "" },
    { id: 4, name: "Model Year", value: responseData?.modelYear ?? "" },
    {
      id: 5,
      name: "Factory Option List",
      value: responseData?.factoryOptionList ?? "",
    },
    {
      id: 6,
      name: "ILA Option List",
      value: responseData?.ilaOptionList ?? "",
    },
    {
      id: 7,
      name: "Confirmation",
      value: responseData?.confirmation ?? "",
    },
    {
      id: 8,
      name: "Reason for Rejection",
      value: responseData?.reasonForRejection ?? "",
    },
  ];

  const colorData = [
    { id: 1, name: "Exterior", value: responseData?.extColor ?? "" },
    { id: 2, name: "Interior", value: responseData?.intColor ?? "" },
  ];

  const specificationData = [{ id: 1, name: "Spec 200", data: responseData?.spec200 ?? "" }];

  const renderData = [
    { id: 1, title: "Vehicle Identifier", data: vehicleIdentifierData },
    { id: 2, title: "Color", data: colorData },
  ];

  if (simSelectorLoading) {
    return <CommonLoader active={simSelectorLoading} />;
  }

  return (
    <div className="border border-gray-300 rounded-lg shadow-lg gap-4">
      {renderData.map((item) => (
        <div className="w-full bg-gray-100 rounded-lg py-2 m-2" key={item.id}>
          <div className="flex w-full justify-start items-center content-center">
            <span className="font-bold mx-4 text-xl">{item.title}</span>
          </div>
          <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
          <div className="grid grid-cols-3 m-4 gap-4">
            {item.data.map((dataItem: any) =>
              dataItem.id === 8 && dataItem.value === "" ? null : (
                <div key={dataItem.id}>
                  <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                    <div className="text-base">{dataItem.name}</div>
                    <div className="text-base break-all text-pretty">{dataItem.value}</div>
                  </div>
                </div>
              ),
            )}
          </div>
        </div>
      ))}
      <div className="flex w-full justify-start items-center content-center">
        <span className="font-bold mx-4 text-xl">Specifications</span>
      </div>
      <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
      {specificationData.map((item: any, index: number) => {
        // console.log("item", item);
        return (
          <div className="grid grid-cols-12 m-2 gap-4 pl-4" key={index}>
            <div className="text-base col-span-2 align-center items-center flex">{item.name}</div>
            <div className="overflow-x-auto py-2 col-start-3 col-end-12">
              {item.data !== "" && (
                <table className="min-w-full">
                  <tr>
                    {item.data?.split("").map((item: string, index: number) => {
                      return (
                        <td key={index} className=" p-2 w-2 text-center">
                          {index + 1}
                        </td>
                      );
                    })}
                  </tr>
                  <tr>
                    {item.data?.split("").map((item: string, index: number) => {
                      return (
                        <td key={index} className="p-2 w-12 text-center">
                          {item}
                        </td>
                      );
                    })}
                  </tr>
                </table>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default OrderChangeResponseFromSimEngine;
